import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from './router'
// import _ from 'lodash'
import union from 'lodash/union'

axios.defaults.baseURL = process.env.VUE_APP_DOMAIN+'/wp-json/';

Vue.use(Vuex)

function createCookie(key, value, date) {
  var expiration = new Date(date).toUTCString();
  var cookie = escape(key) + "=" + escape(value) + ";expires=" + expiration + ";";
  document.cookie = cookie;
  
  // eslint-disable-next-line
  console.log(cookie, "Creating new cookie with key: " + key + " value: " + value + " expiration: " + expiration);
}

function readCookie(name) {
  var key = name + "=";
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(key) === 0) {
      return cookie.substring(key.length, cookie.length);
    }
  }
  return null;
}

function deleteCookie(name) {
  createCookie(name, "", -1);
}

export default new Vuex.Store({
  state: {
    appTitle: "Markets",
    user: null,
    error: null,
    loading: false,
    isAuthenticated: false,
    accessToken: false,
    stallholders: [],
    stalls: [],
    categories: [],
    bookings: [],
    payments: [],
    selectedMarketDate: null,
    stallholderTypes: [
      {
        name: "regular",
        label: "Regular",
        color: "orange"
      },
      {
        name: "casual",
        label: "Casual",
        color: "grey"
      }
    ],
    permissionTypes: [
      { text: "Eat Street Food", value: "food-eat" },
      { text: "Gourmet Food", value: "food-gourmet" },
      { text: "Gravel", value: "gravel"},
      { text: "Tunnel", value: "tunnel" },
      { text: "Tunnel (Saturday Only)", value: "tunnel_day-saturday" },
      { text: "Tunnel (Sunday Only)", value: "tunnel_day-sunday" },
      { text: "Tunnel (First Sunday Only)", value: "tunnel_day-sunday-first" },
      { text: "Tunnel (Second Sunday Only)", value: "tunnel_day-sunday-second" }
    ],
    dialogs: {
      booking: false
    },
    selected: {
      bookingId: false
    },
    have_all_stallholders: false,
    have_all_payments: false,
    have_stalls: false,
    availablePickerMarketsDates: [],
    fetchedPickerMarketYears: [],
    isSaving: false
  },
  getters: {
    getStoreStallholders(state) {
      return state.stallholders;
    },
    getStallholderById: (state, getters) => id => {
      return state.stallholders.find(stallholder => stallholder.id === id);
    },
    getStallholderName: (state, getters) => id => {
      let stallholder = state.stallholders.find(
        stallholder => stallholder.id === id
      );

      if (stallholder) return stallholder.stall_name;

      return false;
    },
    getBooking(state) {
      return id => state.bookings.find(booking => id == booking.id);
    },
    getStallholderTypes(state) {
      return state.stallholderTypes;
    },
    getStallholderType(state) {
      return type =>
        state.stallholderTypes.find(
          stallholderType => stallholderType.name == type
        );
    },
    getStallholderColor(state) {
      return type => {
        let stallholderType = state.stallholderTypes.find(
          stallholderType => stallholderType.name == type
        );
        return stallholderType ? stallholderType.color : ""; // empty should never happen. Only set during dev
      };
    },
    getCategoryById: (state, getters) => id => {
      return state.categories.find(category => category.id === id);
    },
    getStallById: (state, getters) => id =>
      state.stalls.find(stall => stall.id === id),
    getStallName: (state, getters) => id => {
      let stall = state.stalls.find(stall => stall.id === id);

      if (stall) return stall.stall_title;

      return false;
    },
    getDefaultStallholderIdForStall: (state, getters) => id => {
      let stall = state.stalls.find(stall => stall.id === id);

      if (stall && stall.stallholder) return stall.stallholder;

      return false;
    },
    getPaymentById: (state, getters) => id => {
      return state.payments.find(payment => payment.id === id);
    }
  },
  mutations: {
    setDate(state, payload) {
      state.selectedMarketDate = payload;
    },
    setUser(state, payload) {
      state.user = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setAuthentication(state, payload) {
      state.isAuthenticated = payload;
    },
    updateAccessToken: (state, accessToken) => {
      state.accessToken = accessToken;
    },
    setStallholders: (state, payload) => {
      state.stallholders = payload;
    },
    setStallholderStatus: (state, payload) => {
      state.have_all_stallholders = payload;
    },
    setPayments: (state, payload) => {
      state.payments = payload;
    },
    setPaymentsStatus: (state, payload) => {
      state.have_all_payments = payload;
    },
    addPayment: (state, payload) => {
      state.payments.push(payload);
    },
    setStallsStatus: (state, payload) => {
      state.have_stalls = payload;
    },
    addStallholder: (state, payload) => {
      state.stallholders.push(payload);
    },
    updateStallholder: (state, payload) => {
      let index = state.stallholders.findIndex(item => item.id === payload.id);

      if (index !== -1) state.stallholders.splice(index, 1, payload);
    },
    setCategories: (state, payload) => {
      state.categories = payload;
    },
    addCategory: (state, payload) => {
      state.categories.push(payload);
    },
    updateCategory: (state, payload) => {
      let index = state.categories.findIndex(item => item.id === payload.id);

      if (index !== -1) state.categories.splice(index, 1, payload);
    },
    deleteCategory: (state, payload) => {
      let index = state.categories.findIndex(item => item.id === payload);

      if (index !== -1) state.categories.splice(index, 1);
    },
    setStalls: (state, payload) => {
      state.stalls = payload.sort((a, b) => {
        let regexAlpha = /[^a-zA-Z]/g;
        let regexNumber = /[^0-9]/g;

        let aA = a.stall_title.replace(regexAlpha, "").toLowerCase(); //a alpha portion
        let bA = b.stall_title.replace(regexAlpha, "").toLowerCase(); //b alpha portion

        if (aA === bA) {
          // if same alpha
          let aN = parseInt(a.stall_title.replace(regexNumber, ""), 10); //a number portion
          let bN = parseInt(b.stall_title.replace(regexNumber, ""), 10); //a number portion

          return aN === bN ? 0 : aN > bN ? 1 : -1;
        } else {
          return aA === bA ? 0 : aA > bA ? 1 : -1;
        }
      });
    },
    updateStall: (state, payload) => {
      let index = state.stalls.findIndex(item => item.id === payload.id);

      if (index !== -1) state.stalls.splice(index, 1, payload);
    },
    setDialogVisibility: (state, payload) => {
      state.dialogs[payload.dialog] = payload.value;
    },
    setBookings: (state, payload) => {
      state.bookings = payload;
    },
    setSelected: (state, payload) => {
      state.selected[payload.item] = payload.value;
    },
    updateBooking: (state, payload) => {
      let index = state.bookings.findIndex(item => item.id === payload.id);

      if (index !== -1) state.bookings.splice(index, 1, payload);
    },
    updatePickerAvailableMarketsDates: (state, payload) => {
      let mergedDates = state.availablePickerMarketsDates.concat(payload.dates);
      //state.availablePickerMarketsDates = _.union(mergedDates); // incase duplicates
      state.availablePickerMarketsDates = union(mergedDates); // incase duplicates

      if (payload.year) state.fetchedPickerMarketYears.push(payload.year);
    },
    deletePickerAvailableMarketsDate: (state, payload) => {
      console.log("store" + payload);
      let index = state.availablePickerMarketsDates.indexOf(payload);

      if (index !== -1) state.availablePickerMarketsDates.splice(index, 1);
    },
    isSaving: (state, payload) => {
      state.isSaving = payload;
    }
  },
  actions: {
    // eslint-disable-next-line
    userSignIn({ commit }, payload) {
      commit("setLoading", true);
      // firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
      // .then(firebaseUser => {
      //   commit('setUser', {email: firebaseUser.user.email})
      //   commit('setLoading', false)
      //   commit('setError', null)
      //   router.push('/home')
      // })
      // .catch(error => {
      //   commit('setError', error.message)
      //   commit('setLoading', false)
      // })

      // eslint-disable-next-line

      axios
        .post(`/jwt-auth/v1/token`, {
          //axios.post('http://glebe.local/wp-json/aam/v1/authenticate', {

          username: payload.email,
          password: payload.password
        })
        .then(function(response) {
          // eslint-disable-next-line
          console.log(response);
          // eslint-disable-next-line

          if (response.data.success) {
            if (
              response.data.data.user_role.includes("administrator") ||
              response.data.data.user_role.includes("editor")
            ) {
              commit("setUser", { email: payload.email });
              commit("setLoading", false);
              commit("setError", null);
              //commit('setAuthentication', true)

              //document.cookie = 'my_cookie_name='+response.data.data.token // JavaScript
              let d = new Date();
              //createCookie("my_cookie_name2", response.data.data.token, Date.UTC(2019, 12, 12));
              createCookie(
                "wisdombookings",
                response.data.data.token,
                d.getTime() + 1 * 24 * 60 * 60 * 1000
              ); // store for 24hours

              router.push("/markets");
            } else {
              window.alert("No access allowed");
            }
          } else {
            window.alert(response.data.message);
          }
        })
        .catch(function(error) {
          // eslint-disable-next-line
          console.log(error);
          window.alert("Cannot log in, server error");
          // eslint-disable-next-line
          commit("setError", error.message);
          // eslint-disable-next-line
          commit("setLoading", false);
        });
      /*
      Once you get the token, you must store it somewhere in your application, ex. in a cookie or using localstorage.
      From this point, you should pass this token to every API call
      */
    },
    fetchAccessToken({ commit }) {
      //commit('updateAccessToken', readCookie('my_cookie_name2'));
      commit("updateAccessToken", readCookie("wisdombookings"));
    },
    userSignOut({ commit }) {
      deleteCookie("wisdombookings");
      commit("setUser", null);
      commit("updateAccessToken", null);
      router.push("/");
    },
    getStallholders({ commit }) {
      console.log("lngth", this.state.stallholders.length);
      if (!this.state.have_all_stallholders) {
        console.log("fetching stallsholder", this.state.stallholders);

        //commit('updateAccessToken', readCookie('wisdombookings'));
        //axios.get(`/wp/v2/users?roles=stallholder&per_page=100`, {
        axios
          .get(`/wisdom-markets/v1/stallholders`, {
            //axios.get('https://jsonplaceholder.typicode.com/photos', {

            params: {},
            headers: {
              //'Authentication': `Bearer ${this.$store.state.accessToken}`,
              Authorization: `Bearer ${this.state.accessToken}`
            }
          })
          .then(function(response) {
            console.log(response);
            //this.data = response.data;

            // self.pagesTotal = parseInt(response.headers['x-wp-totalpages'])
            //console.warn(response.headers['x-wp-totalpages'])

            let data = response.data;
            console.log(data);
            // data.forEach(item => {
            //     item["stall_id"] = item.id;
            //     item["name"] = item.title;
            //     item["type"] = 'Monthly';
            //   if(item.booking)
            //     item["stallholder"] = item.booking.stallholder_id; // either 1 date or 2 dates separated by : (for a date range)
            //    else
            //    item["stallholder"] = false;
            // });

            commit("setStallholders", data);
            commit("setStallholderStatus", true);
            // self.isLoading = false
          })
          .catch(function(error) {
            console.log(error);
          })
          .then(function() {
            // always executed
          });
      } else {
        console.log("already have stallholders");
      }
    },
    loadStallholder(context, params) {
      console.error({ context });
      console.error(params);

      let stallholderId = params.id;
      // Return a promise so that calling method may show an AJAX spinner gif till this is done

      return new Promise((resolve, reject) => {
        // Load data from server

        // Note: you cannot commit here, the data is not available yet

        axios
          .get(`/wisdom-markets/v1/stallholders/${stallholderId}`, {
            params: {},
            headers: { Authorization: `Bearer ${this.state.accessToken}` }
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(function(error) {
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log("Error", error.message);
            }
            console.log(error.config);

            reject(false);
          });
      });
    },
    loadPayment(context, params) {
      console.error({ context });
      console.error(params);

      let paymentId = params.id;
      // Return a promise so that calling method may show an AJAX spinner gif till this is done

      return new Promise((resolve, reject) => {
        // Load data from server

        // Note: you cannot commit here, the data is not available yet

        axios
          .get(`/wisdom-markets/v1/payments/${paymentId}`, {
            params: {},
            headers: { Authorization: `Bearer ${this.state.accessToken}` }
          })
          .then(response => {
            // The data is available now. Finally we can commit something
            console.log("epp done");
            // context.commit("saveCurrentUser", response.body)  // ref: vue-resource docs

            // Now resolve the promise
            resolve(response.data);
          })
          .catch(function(error) {
            console.error("errrrrrt");
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log("Error", error.message);
            }
            console.log(error.config);

            reject(false);
          });
      });
    },
    getStallholderCategories({ commit }) {
      if (this.state.categories.length == 0) {
        console.log("fetching stallholder categories", this.state.stallholders);
        axios
          .get(`/wisdom-markets/v1/categories`, {
            params: {
              //
            },
            headers: {
              Authorization: `Bearer ${this.state.accessToken}`
            }
          })
          .then(function(response) {
            commit("setCategories", response.data);
          })
          .catch(function(error) {
            console.log(error);
          })
          .then(function() {
            // always executed
          });
      } else {
        console.log("already have stallholder categories");
      }
    },

    // getStalls() {
    //   return axios.get(`/wisdom-markets/v1/stalls`, {
    //       headers: {
    //         'Authorization': `Bearer ${this.state.accessToken}`,
    //       },
    //   });
    // },

    // getMarketDateStallInfo() {
    //     return axios.get(`/wisdom-markets/v1/market/${this.state.selectedMarketDate}`, {

    //   });
    // },

    fetchStallData({ commit, dispatch }) {
      console.log("fetching stall data");

      //axios.get(`/wisdom-markets/v1/stalls`, {
      // axios.all([dispatch('getStalls'), dispatch('getMarketDateStallInfo')])
      // .then(axios.spread(function (stalls, marketDateStalls) {
      //   console.log('Both requests are now complete');
      //   console.warn(stalls, marketDateStalls);

      //   commit('setStalls', stalls.data);
      // }))
      axios
        .get(
          `/wisdom-markets/v1/stalls/${
            this.state.selectedMarketDate ? this.state.selectedMarketDate : ""
          }`,
          {
            params: {
              //
            },
            headers: {
              Authorization: `Bearer ${this.state.accessToken}`
            }
          }
        )
        .then(function(response) {
          commit("setStalls", response.data);
          commit("setStallsStatus", true);
          console.log("got stalls");
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    updateBooking({ commit }, data) {
      commit("updateBooking", data);
    },
    updateDate({ commit, dispatch }, data) {
      console.log("in update datedate", data);

      commit("setDate", data);
      dispatch("fetchStallData", data);
    },
    getPayments({ commit }) {
      //console.log("fetching payments?", this.state.payments.length)
      console.log("fetching payments");
      commit("setPaymentsStatus", false);

      //if(!this.state.have_all_payments) {
      console.log("fetching payments", this.state.stallholders);

      axios
        .get(`/wisdom-markets/v1/payments`, {
          params: {},
          headers: {
            Authorization: `Bearer ${this.state.accessToken}`
          }
        })
        .then(function(response) {
          console.log(response);

          let data = response.data;
          console.log(data);

          commit("setPayments", data);
          commit("setPaymentsStatus", true);
        })
        .catch(function(error) {
          console.log(error);
        })
        .then(function() {
          // always executed
        });

      //}else{
      // console.log("already have payments");
      //}
    }
  }
});
